import { ThemeColors } from '.'

export const asChakraVariable = (
  themeColorSectionKey: string | ThemeColors,
): string => {
  // If it's a ThemeColors object, extract the default value
  const key =
    typeof themeColorSectionKey === 'string'
      ? themeColorSectionKey
      : themeColorSectionKey.default

  // Convert to kebab-case for Chakra v3 compatibility
  // Replace dots with dashes, then convert camelCase to kebab-case
  const formatted = key
    .replace(/\./g, '-')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()
  return `var(--chakra-colors-${formatted})`
}
